'use strict';

$ = jQuery;

var formOffer = $('.form-component');
var cityElement = formOffer.find('.city');
var cpfCnpjElement = formOffer.find('.cpfcnpj');
var cepElement = formOffer.find('.cep');
var phoneElement = formOffer.find('.phone');

var latitude = null;
var longitude = null;

getLocationUser().then(function (coordinates) {
  latitude = coordinates.latitude;
  longitude = coordinates.longitude;
});

validatorConfig();
formValidateConfig(formOffer);
validatorPhone();
maskPhone(phoneElement);
validatorEmail();
validatorCep();
maskCep(cepElement);
validatorCpfCnpj();
maskCpfCnpj(cpfCnpjElement);
loadCityByCep(cepElement, cityElement);
loadDealershipByCity(cityElement);

formOffer.submit(function (event) {

  event.preventDefault();

  var form = jQuery(this),
      fullName = form.find('[name="fullname"]').val(),
      name = form.find('[name="name"]').val(),
      surname = form.find('[name="surname"]').val(),
      sexo = form.find('input[name="sexo"]:checked').parent('label').text().trim(),
      email = form.find('[name="email"]').val(),
      phone = form.find('[name="phone"]').val(),
      cpfcnpj = form.find('[name="cpfcnpj"]').val(),
      cep = form.find('[name="cep"]').val(),
      dealership = form.find('.dealerships input:checked').val(),
      message = form.find('[name="message"]').val(),
      address = form.find('[name="address"]').val(),
      number = form.find('[name="number"]').val(),
      complement = form.find('[name="complement"]').val(),
      neighborhood = form.find('[name="neighborhood"]').val(),
      country = form.find('[name="country"]').val(),
      state = form.find('[name="state"]').val(),
      cityuser = form.find('[name="cityuser"]').val(),
      birthdate = form.find('[name="birthdate"]').val(),
      carplate = form.find('[name="carplate"]').val(),
      maritalstatus = form.find('[name="maritalstatus"]').val(),
      cell_phone = form.find('[name="cell_phone"]').val(),
      honorifics = form.find('[name="honorifics"]').find(":selected").text(),
      formIdentifier = form.find('[name="identificador-form"]').val(),
      category = form.find('[name="categoria"]').val(),
      campaign = form.find('[name="campanha"]').val(),
      brand = form.find('[name="marca"]').val(),
      model = form.find('[name="modelo"]').val(),
      version = form.find('[name="versao"]').val(),
      integrationId = form.find('[name="oferta-id-integracao"]').val(),
      button = form.find('button[type="submit"]');

  if (fullName && fullName != '') {
    fullName = fullName.trim().replace(/( )+/g, ' ');
    name = fullName ? fullName.split(' ')[0].trim() : '';
    surname = fullName.indexOf(' ') !== -1 ? fullName.substr(fullName.indexOf(' ') + 1).trim() : '';
  }

  var customFieldData = [];
  form.find(".custom-fields").each(function () {
    var label = $(this).attr('data-customfield');
    var value = [];

    if ($(this).find('select').length > 0 && $(this).find('select').prop('selectedIndex') > 0) {
      value.push($(this).find(":selected").text());
    } else if ($(this).find('input[type="radio"]').length > 0) {
      value.push($(this).find('input[type="radio"]:checked').val());
    } else if ($(this).find('input[type="checkbox"]').length > 0) {
      $(this).find('input[type="checkbox"]:checked').each(function () {
        value.push($(this).val());
      });
    }

    if (value != '') {
      customFieldData.push({
        label: label,
        value: value
      });
    }
  });

  // Buscando por todas as ofertas selecionadas pelo usuário
  var offers = [];

  if (form.find("[name='lp_offers']").attr('type') === "hidden") {
    offers.push(form.find("[name='lp_offers']").val());
  } else {
    form.find("[name='lp_offers']:checked").each(function () {
      offers.push($(this).val());
    });
  }

  // Pega o texto e os links do disclaimer
  var lgpd_disclaimer = [];

  // Buscando pela LGPD padrão
  if (form.find("[name='lgpd']:checked").length > 0) {
    lgpd_disclaimer.push(getGeneralLawDataProtection(form));
  }

  //Buscando pela LGPD do custom
  if (form.find("[name='custom-lgpd']:checked").length > 0) {
    lgpd_disclaimer.push(getGeneralLawDataProtection(form, 'custom-lgpd'));
  }

  //Buscando pela LGDP do patrocinador
  if (form.find("[name='sponsor-lgpd']:checked").length > 0) {
    lgpd_disclaimer.push(getGeneralLawDataProtection(form, 'sponsor-lgpd'));
  }

  //Pega os valores dos options e salva no array de optins
  var optin = {};
  if (form.find("[name='optin']").length > 0) {
    optin = { 'estadao': form.find("[name='optin']:checked").val() };
  }

  if (form.valid()) {

    var buttonLabel = button.text();
    button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

    grecaptcha.ready(function () {
      grecaptcha.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

        $.ajax({
          url: ajaxHandler.url,
          type: 'POST',
          data: {
            action: 'jc_ajax_form_save_lead',
            name: name,
            surname: surname,
            sexo: sexo,
            email: email,
            phone: phone,
            cpfcnpj: cpfcnpj,
            cep: cep,
            dealership: dealership,
            message: message,
            address: address,
            number: number,
            complement: complement,
            neighborhood: neighborhood,
            country: country,
            state: state,
            cityuser: cityuser,
            birthdate: birthdate,
            carplate: carplate,
            maritalstatus: maritalstatus,
            cell_phone: cell_phone,
            honorifics: honorifics,
            customFieldData: customFieldData,
            offers: offers,
            formIdentifier: formIdentifier,
            category: category,
            campaign: campaign,
            optin: optin,
            brand: brand,
            model: model,
            version: version,
            integrationId: integrationId,
            getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
            latitude: latitude,
            longitude: longitude,
            token: grecaptchaToken,
            url_page: window.location.href,
            lgpd_disclaimer: lgpd_disclaimer
          },
          success: function success(response) {
            if (response && response.success) {
              var leadId = response.data.leadId;
              // send_lead_tracking_event();
              setLeadIdSessionStorage(leadId);
              gtm_get_data_and_send_lead_saved(leadId, 'landingPage').then(function () {
                window.location.href += (window.location.href.indexOf("?") > -1 ? '&' : '?') + 'pagina=obrigado';
              });
            } else {
              $("#form-error").modal("show");
              button.prop('disabled', false).html(buttonLabel);
            }
          },
          error: function error(data) {
            $("#form-error").modal("show");
            button.prop('disabled', false).html(buttonLabel);
          }
        });
      });
    });
  }

  function getGeneralLawDataProtection(form) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'lgpd';


    var text = form.find("[name='" + type + "']:checked").nextAll('.custom-control-description').text().replace(/\\n|\s{2,}/gm, ' ').trim();
    var url = [];

    form.find("[name='" + type + "']:checked").nextAll('.custom-control-description').find('a').each(function () {
      url += $(this).attr('href');
      url += ' ; ';
    });

    return {
      'text_disclaimer': text,
      'url_disclaimer': url
    };
  }
});